export const FIRM_SIDS_TO_EXCLUDE_FROM_SESSION_LOGGING = [
  'rentana', // Rentana
  '03ho5at5397b', // AIR
]
